
<v-dialog
    :key="value.type + '_' + value.id"
    v-model="touched"
    max-width="480"
    persistent
    scrollable
>
    <template #activator="{ on, attrs }">
        <slot v-bind="{ on, attrs }"></slot>
    </template>

    <v-card>
        <v-card-title class="customized-primary white--text">{{ t('app_content_title_update_tags') }}</v-card-title>

        <v-card-text class="pb-0">
            <v-form class="mt-6">
                <v-text-field
                    v-model="value.name"
                    type="text"
                    :label="t('app_content_label_name')"
                    required
                    outlined
                    dense
                    disabled
                    :error-messages="form.errors.get('name')"
                ></v-text-field>
                <v-autocomplete
                    v-model="value.tags"
                    :items="tags.data"
                    item-text="slug"
                    item-value="slug"
                    filled
                    chips
                    :label="t('app_content_label_tags')"
                    multiple
                    dense
                    outlined
                    deletable-chips
                    append-icon="mdi-chevron-down"
                    :error-messages="form.errors.get('tags')"
                ></v-autocomplete>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-btn
                color="orange"
                @click="cancel"
                width="45%"
                dark
            >{{ t('general_action_back') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="submit"
                width="45%"
                dark
            >{{ t('general_action_update') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
